import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { PublishDraftThreadsAction } from '../../domains/publishDraftThreads/actions.types';

import type { PublishDraftThreads } from './types';

const initialState: PublishDraftThreads = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<PublishDraftThreads, PublishDraftThreadsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUBLISH_DRAFT_THREADS.PENDING':
      return moveToPending(state, [action.payload.curatedThreadListId]);
    case 'PUBLISH_DRAFT_THREADS.REJECTED':
      return moveToRejected(state, [action.payload.curatedThreadListId], action.payload.error);
    case 'PUBLISH_DRAFT_THREADS.FULFILLED':
      return moveToFulfilled(state, {
        [action.payload.curatedThreadListId]: {
          id: action.payload.curatedThreadListId,
          threadIds: action.payload.threadIds,
          retryableErrorThreadIds: action.payload.retryableErrorThreadIds,
          nonRetryableErrorThreadIds: action.payload.nonRetryableErrorThreadIds,
        },
      });
    case 'PUBLISH_DRAFT_THREADS.RESET':
      return initialState;
    default:
      return state;
  }
};

export default reducer;
